import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const desafioFinalizadoStateSlice = createSlice({
	name: 'desafioFinalizadoState',
	initialState,
	reducers: {
		setDesafioFinalizado: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setDesafioFinalizado } = desafioFinalizadoStateSlice.actions;

export default desafioFinalizadoStateSlice.reducer;
